/**
 * @generated SignedSource<<88eb537726d54a46f6ad0a32b779417e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"issueViewEntitlementField_servicedeskCustomerServiceEntitlementsField_EntitlementsField" | "ui_businessGoalsIssueViewField_GoalsInlineEditViewField" | "ui_issueViewLayoutCascadingSelectField_IssueViewCascadingSelectField" | "ui_issueViewLayoutLabelsSystemField_IssueViewLabelsSystemField" | "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField">;
  readonly " $fragmentType": "relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer";
};
export type relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer$key = {
  readonly " $data"?: relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer$data;
  readonly " $fragmentSpreads": FragmentRefs<"relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayCascadingSelectFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayGoalsFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "jsmProductsEntitlementsM2Flag"
    }
  ],
  "kind": "Fragment",
  "name": "relayLayoutItems_issueViewLayoutTemplatesLayoutItem_RelayLayoutItemFragmentContainer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueViewLayoutLabelsSystemField_IssueViewLabelsSystemField"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_issueViewLayoutSingleSelectField_IssueViewSingleSelectField"
    },
    {
      "condition": "issueViewRelayCascadingSelectFlag",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_issueViewLayoutCascadingSelectField_IssueViewCascadingSelectField"
        }
      ]
    },
    {
      "condition": "jsmProductsEntitlementsM2Flag",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "issueViewEntitlementField_servicedeskCustomerServiceEntitlementsField_EntitlementsField"
        }
      ]
    },
    {
      "condition": "issueViewRelayGoalsFlag",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_businessGoalsIssueViewField_GoalsInlineEditViewField"
        }
      ]
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "c0237afb4d3ccffd2c9e26c777d618ca";

export default node;
